// Core
import { handleActions } from 'redux-actions';
import { Map } from 'immutable';

// Instruments
import { reviewsActions as actions } from './actions';

const intitalState = Map({
    'turpravda': Map(),
});

export const reviewsReducer = handleActions({
    [actions.getTurpravdaReviewsSuccess]: (state, { payload: { hotelId, reviewsHtml }}) => {
        return state.setIn(['turpravda', hotelId], reviewsHtml);
    },
}, intitalState);
